import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["explicit"]

  markExplicit() {
    if (this.hasExplicitTarget) {
      this.explicitTarget.value = "1"
    }
  }
}
